import {useEffect, useRef, useState} from "react";
import Big from "big.js";
import {Dropdown} from 'react-bootstrap';
import InstrumentIcon from "../../../../components/instrument-icon";
import SvgIcon from "../../../../components/svg-icon";
import {useTranslation} from "react-i18next";

const BuyCryptoTargetDropdown = ({selectedCurrency, handleChangeWallet, currencyList}) => {

    const {t} = useTranslation()
    const [show, setShow] = useState(false);
    const dropdownRef = useRef(null);
    const [searchTerm, setSearchTerm] = useState('');
    const [currencyListFiltered, setCurrencyListFiltered] = useState([]);

    useEffect(() => {
        setCurrencyListFiltered(currencyList?.filter(i => i.code?.toUpperCase().includes(searchTerm?.toUpperCase()) || i.name?.toUpperCase().includes(searchTerm?.toUpperCase())))
    }, [currencyList, searchTerm])

    // Handle click outside dropdown
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setShow(false);
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    return (
        <Dropdown
            className="modal__wallet-dropdown width-unset flex-column"
            show={show}
            onToggle={setShow}
            ref={dropdownRef}
        >
            <span className="text-secondary">{t('buy-crypto.to-currency', 'To Currency')}</span>
            <Dropdown.Toggle
                className="modal__wallet-dropdown-btn"
                id="modalWallet1"
                aria-expanded={show}
                onClick={() => setShow(!show)}
            >
                <div className="d-flex gap-2 align-items-center">
                    <InstrumentIcon code={selectedCurrency?.code}/>
                    {Big(selectedCurrency?.balance || 0).toFixed(selectedCurrency?.code === 'TRY' || selectedCurrency?.code === 'USDT' ? 2 : 8)}
                </div>

                <SvgIcon id={'right-down'}/>
            </Dropdown.Toggle>

            <Dropdown.Menu className="dropdown-menu modal__wallet-menu" aria-labelledby="modalWallet1">
                <div className="modal__wallet-search">
                    <input
                        type="text"
                        name="search"
                        className="search__input"
                        placeholder="Search currencies"
                        value={searchTerm}
                        onChange={(e) => setSearchTerm(e.target.value)}
                    />
                </div>

                <ul className="modal__wallet-currencies">
                    {currencyListFiltered
                        ?.filter((wallet) => wallet?.code.toLowerCase().includes(searchTerm.toLowerCase()))
                        .map((wallet) => (
                            <li
                                key={wallet?.code}
                                onClick={(e) => {
                                    e.stopPropagation();
                                    e.preventDefault();
                                    handleChangeWallet(wallet);
                                    setShow(false); // Close dropdown after selecting
                                }}
                            >
                                <span>
                                  <InstrumentIcon code={wallet?.code}/>
                                    {wallet?.code}
                                </span>
                                <span>{Big(wallet?.balance || 0).toFixed(wallet?.code === 'TRY' || wallet?.code === 'USDT' ? 2 : 8)}</span>
                            </li>
                        ))}
                </ul>
            </Dropdown.Menu>
        </Dropdown>
    )

}


export default BuyCryptoTargetDropdown
